import { render, staticRenderFns } from "./VerificationPage.vue?vue&type=template&id=5ad66748&scoped=true"
import script from "./VerificationPage.vue?vue&type=script&lang=js"
export * from "./VerificationPage.vue?vue&type=script&lang=js"
import style0 from "./VerificationPage.vue?vue&type=style&index=0&id=5ad66748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad66748",
  null
  
)

export default component.exports